import React from 'react'
import styled from 'styled-components'
import * as styles from './Services.module.css'
import gif from '../../images/deliver.gif'
import gif2 from '../../images/like.gif'
import gif3 from '../../images/guarranted.gif'
const Service = styled.div
`
display:grid;
grid-template-columns: repeat(3,1fr);
margin: 0 3rem;
gap:3rem;
@media screen and (max-width:998px) {
    display: flow-root;
}

`

const Services = () => {
  return (
    <Service className='mt-16'>
        <div className={styles.service}>
        <div className='relative float-right'>
          <img src={gif} className={styles.delivery} alt='service' />
            </div>
<h1>Fast Delivery</h1>
<p>Our delivery is incredibly fast, you don't have to wait too much than necessary , few days 
    for your products to arrive !
</p>

        </div>
        <div className={styles.service}>
        <div className='relative float-right'>
          <img src={gif2} className={styles.delivery} alt='service' />
            </div>
<h1>Fast Delivery</h1>
<p>Our delivery is incredibly fast, you don't have to wait too much than necessary , few days 
    for your products to arrive !
</p>
        </div>
        <div className={styles.service}>
        <div className='relative float-right'>
          <img src={gif3} className={styles.delivery} alt='service' />
            </div>
<h1>Fast Delivery</h1>
<p>Our delivery is incredibly fast, you don't have to wait too much than necessary , few days 
    for your products to arrive !
</p>
        </div>
    </Service>
  )
}

export default Services
